import { emptyWizardForm } from './postJobWizardSchema';
import { seniorityFromSelection, seniorityToSelection } from './wizardConstants';

export function jobToWizardForm(job) {
  if (!job) return emptyWizardForm();
  return {
    title: job.title === 'Untitled position' ? '' : job.title || '',
    category_id: job.category_id ? String(job.category_id) : '',
    employment_type: job.employment_type || 'full-time',
    senioritySelection: seniorityToSelection(job.seniority_level),
    salary_min: job.salary_min > 0 ? String(job.salary_min) : '',
    salary_max: job.salary_max > 0 ? String(job.salary_max) : '',
    salary_currency: job.salary_currency || 'EUR',
    salary_period: job.salary_period || 'yearly',
    location_eligibility: job.location_eligibility || '',
    location_country: job.location_country || '',
    timezone_requirement: job.timezone_requirement || '',
    description: job.description === 'Draft in progress.' ? '' : job.description || '',
    application_method: job.application_method || 'rwm_flow',
    application_url: job.application_url || '',
    application_email: job.application_email || '',
    skill_ids: job.skills ? job.skills.map((s) => s.id) : [],
  };
}

export function wizardFormToPayload(form) {
  const seniority = seniorityFromSelection(form.senioritySelection);
  const payload = {
    title: form.title.trim(),
    category_id: form.category_id ? Number(form.category_id) : undefined,
    employment_type: form.employment_type,
    salary_min: form.salary_min !== '' ? Number(form.salary_min) : undefined,
    salary_max: form.salary_max !== '' ? Number(form.salary_max) : undefined,
    salary_currency: form.salary_currency,
    salary_period: form.salary_period,
    timezone_requirement: form.timezone_requirement.trim() || null,
    description: form.description,
    application_method: form.application_method,
    application_url: form.application_method === 'external_url' ? form.application_url : null,
    application_email: form.application_method === 'email' ? form.application_email : null,
    skill_ids: form.skill_ids.length > 0 ? form.skill_ids : [],
  };

  if (seniority.length > 0) {
    payload.seniority_level = seniority;
  }

  if (form.location_country) {
    payload.location_country = form.location_country;
  } else if (form.location_eligibility) {
    payload.location_eligibility = form.location_eligibility;
  }

  return Object.fromEntries(
    Object.entries(payload).filter(([key, v]) => {
      if (key === 'skill_ids') return true;
      return v !== undefined && v !== '';
    })
  );
}
